module.exports = __webpack_public_path__ + "static/orb-a64b81ae8d1b03f4aa1e2f8b29836b11.jpg";